// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceTransferResource extends Resource {
    basePath: string = 'clients/service-transfer/';
}
